<template>
  <div>
    <h2 class="tc">{{noticeInfo.newsTitle}}</h2>
    <el-row style="margin-top:20px">
      <el-col :span="6" :offset="6">
        <div class="tc f_gray">来源：{{noticeInfo.source}}</div>
      </el-col>
      <el-col :span="6">
        <div class="tc f_gray">时间：{{noticeInfo.deployTime}}</div>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <div id="content">
     
    </div>
    <div style="display:flex;justify-content: center;margin-top: 20px;">
      <el-button @click="goBack" size="medium" class="btn1">返回通知列表</el-button>
    </div>
  </div>
</template>
<script>
import {queryNoticeInfo} from '@/api/notice.js'
export default {
  name: 'noticeInfo',
  data() {
    return {
      noticeInfo:{}
    };
  },
  mounted() { 
    let id=this.$route.query.id
    this.getNoticeInfo(id)
  },
  methods: {
    async getNoticeInfo(id){
      const data=await queryNoticeInfo(id)
      console.log(data)
      if(data.msgCode==0){
        this.noticeInfo=data.data
        document.getElementById('content').innerHTML = data.data.newsContent

      }
    },
    goBack() {
      this.$router.push("/userCenter/notice");
    },
  },
};
</script>
<style>
.btn1.el-button {
  background-color: #008A2C;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>